import { scrollToElement } from "lib/userFunctions";
import { MEETING_STAGE } from "../AuthorMeeting";
import { StagePuzzle } from "./StagePuzzle";
import { StageCover }  from "./StageCover";
import { StageBookCard } from "./StageBookCard";
import { StageTalk } from "./StageTalk";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { storeMeeting } from "../apiMeeting";
import { useEffect } from "react";
import { toast } from 'react-toastify';
import { createFetchErrorMessage } from "utils/api/Api";
import { useLocation } from "react-router-dom";

export const MeetingStage = ({meeting, stage=MeetingStage.READY, changeStage=f=>f})=>{
    const id = new URLSearchParams(useLocation().search).get('id');
    useEffect(() => {
        scrollToElement();
    }, []);
    const queryClient = useQueryClient();

    const storeMutate = useMutation({
        mutationFn:storeMeeting,
        onSuccess:(res)=>{
            const oldData =queryClient.getQueryData(['meeting', id]);
            queryClient.setQueryData(['meeting', id], {...oldData, data:{...oldData.data, meetingUser:res.data}});
        },
        onError: (err)=>{
            toast.error( createFetchErrorMessage(err).message );
        }
    });

    switch(stage){
        case MEETING_STAGE.READY:
            return null;
        case MEETING_STAGE.PUZZLE:        
            return <StagePuzzle onNextStage={()=>changeStage(MEETING_STAGE.COVER)} meeting={meeting} />;
        case MEETING_STAGE.COVER:
            scrollToElement();
            return <StageCover id={meeting?.meeting.id} cover={meeting?.meeting.cover} storeMutate={storeMutate} />;
        case MEETING_STAGE.CARD:
            scrollToElement();
            return <StageBookCard id={meeting?.meeting.id} bookCard={meeting?.meeting.bookCard} storeMutate={storeMutate} />;
        case MEETING_STAGE.TALK:
        default:
            return <StageTalk meeting={meeting} storeMutate={storeMutate} />;
    }
};